import styled from 'styled-components';
import { Icon } from '../../../stories/atoms';
import { ThemeMode } from '../../../global-state/themeContext';
import { muiTheme } from '../../../theme';

const getIconColor = (mode: ThemeMode, isSuccess: boolean) => {
  if (isSuccess) {
    return mode === 'dark' ? muiTheme.color.success : muiTheme.color.validationGreen;
  }

  return mode === 'dark' ? muiTheme.color.error : muiTheme.color.red;
};

export const StyledIcon = styled(Icon)<{ isSuccess: boolean }>`
  width: ${({ theme }) => theme.spacing(12)};
  height: ${({ theme }) => theme.spacing(12)};
  margin: ${({ theme }) => theme.spacing(3)};
  color: ${({ theme: { palette }, isSuccess }) => getIconColor(palette.mode, isSuccess)};
`;
